@if (editMode$()) {
  <!-- <pre>
    {{ formErrors | json }}
  </pre> -->
  <div class="content" animate.enter="fade-in" animate.leave="fade-out">
    <ng-container [ngTemplateOutlet]="edit"></ng-container>
  </div>
} @else {
  <div class="content" animate.enter="fade-in" animate.leave="fade-out">
    <ng-container [ngTemplateOutlet]="view"></ng-container>
  </div>
}

<ng-template #view>
  @let event = event$();
  <div *ngIf="event" class="p-2">
      @let cover = event.media?.cover;
      @let description = event.description;
      @let color = event.color || defaultColor;
      @let contrast = contrastColor$();
      @let joinLink = joinLink$();
      @let roomName = event.properties?.['room_name'];
      @let lobbyBypass = event.properties?.['lobby_bypass'] ?? null;
  
      @let value = value$();

      @if (cover?.src) {
        <div class="position-relative mb-3 rounded-3 overflow-hidden shadow-sm">
          <img
            [src]="cover!.src | serverAuthUrl | safeUrl"
            alt="Event media"
            class="thumbnail"
          />
          @let name = event.name;
          @if (name) {
            <div class="position-absolute bottom-0 start-0 end-0 p-3 bg-gradient-dark">
              <!-- <h6 class="text-white mb-0 fw-bold" [translate]="name"></h6> -->
              <h6 class="text-white mb-0 fw-bold">{{ name }}</h6>
            </div>
          }
        </div>
      }
  
      <div *ngIf="value" class="d-flex flex-column gap-3">
        <!-- When -->
        <div class="card border-0 shadow-sm h4" [ngStyle]="{ 'background-color': color, 'color': contrast }">
          <div class="card-body py-3 px-2 d-flex flex-column align-items-center">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center px-3 pb-1 border-bottom" [style.--cui-border-color]="contrast">
                <svg cIcon name="cilClock" width="18" class="me-2 lex-shrink-0 "></svg>
                <span [translate]="'calendar.event.when'" class="fw-bold small flex-fill"></span>
              </div>
              <div class="px-3 pt-2">
                <!-- 
                @let timezone = localTimezone;
                @let locale = currentLanguage; 
                -->
                <div class="small fw-semibold text-center">
                  {{ value.timeFrom | date:'EEE, MMM d, y' }}
                  <!-- {{ value.timeFrom | date:'EEE, MMM d, y':'':localTZ }} -->
                </div>
                <div class="small text-center">
                  {{ value.timeFrom | date:'shortTime' }} – {{ value.timeTo | date:'shortTime' }}
                  <!-- {{ value.timeFrom | date:'shortTime':'':localTZ }} – {{ value.timeTo | date:'shortTime':'':localTZ }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (description) {
          <!-- Description -->
          <div class="card border-0 shadow-sm">
            <div class="card-body py-3 px-2">
              <div class="d-flex align-items-center mb-1">
                <svg cIcon name="cilDescription" width="18" class="text-secondary me-2 lex-shrink-0 "></svg>
                <span [translate]="'calendar.event.description'" class="fw-bold small flex-fill"></span>
              </div>
              <div class="w-100"
                class="small text-dark"
                style="line-height: 1.6;"
                [innerHTML]="description | translate"
              ></div>
            </div>
          </div>
        }
        
        @if (roomName) {
          <div class="card border-0 shadow-sm">
            <div class="card-body py-3 px-2">
              <div class="d-flex align-items-center mb-1">
                <svg cIcon name="cilRoom" width="18" class="text-secondary flex-shrink-0 me-2"></svg>
                <span [translate]="'calendar.event.roomName'"class="fw-bold small flex-fill"></span>
              </div>
              <div class="w-100 overflow-hidden small">
                  <span>{{roomName}}</span>
              </div>
            </div>
          </div>    
        }

        @if (joinLink) {
          <div class="card border-0 shadow-sm">
            <div class="card-body py-3 px-2">
              <div class="d-flex align-items-center mb-1">
                <svg cIcon name="cilLink" width="18" class="text-secondary flex-shrink-0 me-2"></svg>
                <span [translate]="'calendar.event.joinLink'"class="fw-bold small flex-fill"></span>
                <span (click)="copyLink(joinLink)" cInputGroupText role="button" class="text-secondary align-self-flex-end flex-shrink-0 ">
                  <svg cIcon name="cilCopy" width="18"></svg>
                </span>
              </div>
              <div class="w-100 overflow-hidden small">
                  <a [href]="joinLink" target="_blank" rel="noopener"color="primary" (click)="openLink(joinLink)">{{joinLink}}</a>
              </div>
            </div>
          </div>    
        }

        <!-- Theme Color -->
        <div class="card border-0 shadow-sm">
          <div class="card-body py-3 px-2">
            <div class="d-flex align-items-center mb-1">
              <svg cIcon name="cilColorPalette" width="18" class="text-secondary me-2 lex-shrink-0 "></svg>
              <span [translate]="'calendar.event.color'" class="fw-bold small flex-fill"></span>
            </div>
            <div class="w-100 d-flex align-items-center gap-2">
              <div
                class="rounded-3 shadow-sm border flex-shrink-0"
                [style.background-color]="color"
                style="width: 36px; height: 36px;"
              ></div>
              <span class="small text-muted">{{ color }}</span>
            </div>
          </div>
        </div>
        
        <c-form-check sizing="xl" switch>
          <input cFormCheckInput [attr.checked]="lobbyBypass" disabled type="checkbox" />
          <label cFormCheckLabel [translate]="'calendar.event.lobbyBypass'"></label>
        </c-form-check>
      </div>
      <ng-container *ngIf="controlsTemplate() as template">
        <ng-container *ngTemplateOutlet="template; context: { detail: this, entity: event$(), editMode: false }"></ng-container>
      </ng-container>
      <!--
      <div class="mt-4 d-grid gap-2">
        < !-- @if (link) {
          <a
            [href]="link"
            target="_blank"
            rel="noopener"
            cButton
            color="primary"
            block
          >
            <svg cIcon name="cilExternalLink" class="me-2"></svg>
            {{ 'actions.join' | translate }}
          </a>
        } -- >
        <button cButton color="secondary" block (click)="onCancel()">
          {{ 'actions.close' | translate }}
        </button>
      </div>
      -->
  </div>
</ng-template>

<ng-template #edit>
<form *ngIf="form() as form" [formGroup]="form" cForm class="p-2" novalidate>
    @if (form.controls['media']; as ctrl) {
      <div [cFormFloating]="true" class="mb-3">
        @let media = form.get('media')?.value;
        @let cover = media?.cover;
        @let isDefaultMedia = media?.id=='0';
        <div *ngIf="cover" class="media-preview text-center"
            [class.dragging]="isDragging" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
            (dragleave)="isDragging = false" (click)="fileInput.click()">
            <img [src]="cover.src | serverAuthUrl | safeUrl" alt="Image" class="thumbnail" />
            @if (isDefaultMedia) {
              <span [translate]="'media.upload.dropOrClickToUpload'"></span>
            } 
            @else {
              <button cButton type="button" size="sm" color="danger" (click)="onMediaRemove($event)">
                <svg cIcon name="cilX" aria-label="Close" ></svg>
              </button>
            }
            <div *ngIf="file" class="file-size text-muted">{{ file.size | filesize }}</div>
        </div>
        <!-- @if (uploading()) {
            <progress 
                [value]="uploadProgress$()" 
                color="primary" 
                class="mt-3" 
                height="8"
                animated
                animate.leave="leaving">
            </progress>
        } -->
        <c-input-group [cFormFloating]="true" class="mt-2 path">
            <input cFormControl 
                    id="media" 
                    type="text" 
                    [value]="!isDefaultMedia ? cover?.src : null"
                    disabled
                    placeholder="No media selected"
                    aria-label="media path"
                    [valid]="undefined"
                    [class.is-valid]="false"/>
            @if (uploading()) {
                <div class="upload-progress" [style.width.%]="uploadProgress$()" animate.leave="leaving"></div>
            }
            <span cInputGroupText class="upload" (click)="fileInput.click()">
                <svg cIcon name="cilCloudUpload"></svg>
            </span>
            <label cLabel [translate]="'calendar.event.media'"></label>
            @if (isDefaultMedia) {
              <!-- <c-form-feedback [valid]="!isDefaultMedia" [translate]="'calendar.event.validation.mediaRequired'"></c-form-feedback> -->
            }
        </c-input-group>

        <!-- <div *ngIf="uploadError" class="alert alert-danger mt-3 py-2">
            Upload failed. Please try again.
        </div> -->

        <input #fileInput type="file" class="d-none" (change)="onFileSelected($event)" />
      </div>
    }
    @if (form.controls['name']; as ctrl) {
      <div [cFormFloating]="true" class="mb-3">
        <input cFormControl formControlName="name" id="name" [valid]="isValid(ctrl)" required/>
        <label cLabel for="name" [translate]="'calendar.event.name'"></label>
        @if (ctrl.invalid) {
          <c-form-feedback [valid]="!ctrl.invalid">
            @if (ctrl.hasError('required')) {
              <span [translate]="'calendar.event.validation.nameRequired'"></span>
            } @else if (ctrl.hasError('minlength')) {
              <span [translate]="'calendar.event.validation.nameMinLength'" [translateParams]="{ minLength: 3 }"></span>
            } 
          </c-form-feedback>
        }
      </div>
    }

    <div [cFormFloating]="true" class="mb-3">
      <textarea cFormControl formControlName="description" id="description" rows="5"></textarea>
      <label cLabel for="description" [translate]="'calendar.event.description'"></label>
    </div>

    @if (form.controls['joinLinkOrRoomName']; as ctrl) {
      <div class="mb-3">
        @let joinLinkOrRoomName = joinLinkOrRoomName$();
        @let joinLinkOrRoomNameState = joinLinkOrRoomNameState$();
        <c-input-group [cFormFloating]="true">
          <input cInput cFormControl formControlName="joinLinkOrRoomName" id="joinLinkOrRoomName" [class.round]="joinLinkOrRoomNameState!='link'" [valid]="isValid(ctrl)" required/>
          @if (joinLinkOrRoomNameState=='link') {
            <span cInputGroupText role="button" (click)="copyLink(joinLinkOrRoomName)">
              <svg cIcon name="cilCopy"></svg>
            </span>
            <!-- <span cInputGroupText role="button" (click)="openLink(joinLinkOrRoomName)">
              <svg cIcon name="cilLink"></svg>
            </span> -->
          }
          <label cLabel for="joinLinkOrRoomName" >{{joinLinkOrRoomNameLabel$() | async}}</label>
          @if (ctrl.invalid) {
            <c-form-feedback [valid]="!ctrl.invalid">
              @if (ctrl.hasError('required')) {
                <span [translate]="'calendar.event.validation.joinLinkRequired'"></span>
              } @else if (ctrl.hasError('exists')) {
                <span [translate]="'calendar.event.validation.roomNameExists'"></span>
              } 
            </c-form-feedback>
          }
        </c-input-group>
        @if (joinLinkOrRoomNameState=='room') {
          @let joinLink = joinLink$();
          @if (joinLink) {
            <div class="form-text joinLink">
              <div>
                <span>{{`${'calendar.event.joinLink' | translate}: `}}</span>
                <a [href]="joinLink" target="_blank" (click)="openLink(joinLink)">{{joinLink}}</a>
              </div>
              <span (click)="copyLink(joinLink)">
                <svg cIcon name="cilCopy"></svg>
              </span>
            </div>
          }
        }
      </div>
    }

    <!-- 
        <input cFormControl formControlName="location" id="location" />
        <label cLabel for="location" [translate]="'calendar.event.joinLink'"></label>
    </div> -->

    <c-input-group [cFormFloating]="true" class="mb-3">
      <input cFormControl 
            id="timeFrom" 
            formControlName="timeFrom" 
            [owlDateTime]="dateTimePickerDateFrom"         
            [min]="timeFromMin"
            [max]="timeFromMax"
            placeholder="Time from" 
            aria-describedby="timeFromTrigger" 
            aria-label="Time from"
            readonly
            required/>
      <span cInputGroupText id="timeFromTrigger" class="trigger" [owlDateTimeTrigger]="dateTimePickerDateFrom">
        <svg cIcon name="cilCalendar"></svg>
      </span>
      <owl-date-time
        #dateTimePickerDateFrom 
        [pickerMode]="platform.is('mobile') ? 'dialog' : 'popup'"
        (dateChange)="onTimeFromChange($event)">
      </owl-date-time>
      <label cLabel for="timeFrom" [translate]="'calendar.event.timeFrom'"></label>
    </c-input-group>

    <c-input-group [cFormFloating]="true" class="mb-3">
      <input cFormControl 
            id="timeTo" 
            formControlName="timeTo"
            [owlDateTime]="dateTimePickerDateTo"
            [min]="timeToMin"
            [max]="timeToMax"
            placeholder="Time to" 
            aria-describedby="timeToTrigger" 
            aria-label="Time to"
            readonly
            required/>
      <span cInputGroupText id="timeToTrigger" class="trigger" [owlDateTimeTrigger]="dateTimePickerDateTo">
        <svg cIcon name="cilCalendar"></svg>
      </span>
      <owl-date-time #dateTimePickerDateTo></owl-date-time>
      <label cLabel for="timeTo" [translate]="'calendar.event.timeTo'"></label>
    </c-input-group>

    <!-- <div class="mb-3">
        <label cFormLabel>Timezone</label>
        <input cFormControl type="text" formControlName="timezoneId" />
    </div> -->

    <!-- <div class="mb-3">
        <label cFormLabel>Tags (comma separated)</label>
        <input cFormControl type="text" formControlName="tags" />
    </div> -->

    @if (form.controls['color']; as ctrl) {
      <c-input-group [cFormFloating]="true" class="mb-3">
        <input cFormControl 
              id="color" 
              type="text" 
              formControlName="color" 
              placeholder="defaultColor" 
              aria-label="Color" 
              [valid]="isValid(ctrl)" 
              readonly required/>
        <div cInputGroupText 
            ngx-colors-trigger
            [overlayClassName]="'color-picker-overlay'"
            class="color-preview" 
            [style.background]="form.controls['color'].value || defaultColor"
            (input)="onColorPickerInput($event)">
        </div>
        <label cLabel for="color" [translate]="'calendar.event.color'"></label>
        <!-- <ngx-colors
          class="suffix"
          matSuffix
          ngx-colors-trigger
          formControlName="colorPicker"
        ></ngx-colors> -->
        @if (ctrl.invalid) {
          <c-form-feedback [valid]="!ctrl.invalid">
            @if (ctrl.hasError('required')) {
              <span [translate]="'calendar.event.validation.colorRequired'"></span>
            }
          </c-form-feedback>
        }
      </c-input-group>
    }

    @if (form.controls['lobbyBypass']; as ctrl) {
      <c-form-check *ngIf="ctrl.value!==undefined" sizing="xl" switch>
        <input
          cFormCheckInput
          formControlName="lobbyBypass"
          type="checkbox"
        />
        <label cFormCheckLabel [translate]="'calendar.event.lobbyBypass'"></label>
      </c-form-check>
    }

    <ng-container *ngIf="controlsTemplate() as template">
      <ng-container *ngTemplateOutlet="template; context: { detail: this, entity: event$(), editMode: true }"></ng-container>
    </ng-container>

    <!--
     <div class="d-grid gap-2 mt-4">
      @let formState = formState$();
      <button
          cButton
          color="primary"
          [disabled]="!(formState.valid && formState.dirty)"
          (click)="onSave()"
      >
      {{'actions.save' | translate}}
      </button>
      <button
          cButton
          color="secondary"
          [disabled]="false && !formState.dirty"
          (click)="onCancel()"
      >
      {{'actions.cancel' | translate}}
      </button>
      <button
        *ngIf="eventId$()"
        cButton
        color="danger"
        (click)="onDelete()"
      >
        {{'actions.delete' | translate}}
      </button> 
    </div>
    -->
</form>
</ng-template>
